"use client";

import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const UserDrivenFeedbackProductTileUndoOverlay: React.FC<{
  onUndoClick: () => void;
}> = ({ onUndoClick }) => {
  return (
    <InnerContainer onClick={(e) => e.preventDefault()}>
      <Column
        align="center"
        justify="center"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        <StyledTypography variant="paragraphSansMedium" align="center">
          <StrictLocalMsg
            defaultMessage="Brand hidden from recommendations."
            description={{
              text: "A piece of text on product tile stating this brand will be hidden.",
              img: "https://cdn.faire.com/fastly/dda030670d3c1950416fd0e0a9b3dbac3b4df9c608c3b8a4fe969309faaf3e11.png",
            }}
          />
        </StyledTypography>
        <Spacer size="1x" />
        <Button variant="tertiary" onClick={onUndoClick}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Undo"
              description={{
                text: "A text button for user to perform an undo action",
                img: "https://cdn.faire.com/fastly/dda030670d3c1950416fd0e0a9b3dbac3b4df9c608c3b8a4fe969309faaf3e11.png",
              }}
            />
          </Typography>
        </Button>
      </Column>
    </InnerContainer>
  );
};

const InnerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 200;
  background-color: ${Core.surface.inverse}90;
  left: 0;
  top: 0;
  cursor: default;
`;

const StyledTypography = styled(Typography)`
  margin-top: -100px;
`;
